import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import { CurrencyIcon } from "../../../constants/assets";
import OddsChip from "../race/chip";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import {
  StyledProfileTableRow,
  StyledTableContainer,
} from "../table-styling/table-styling";

const ActivitiesTable = ({ activities }) => {
  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ACTIVITY</TableCell>
            <TableCell>DATE</TableCell>
            {/* <TableCell>ODDS</TableCell> */}
            <TableCell>Total Bets</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activities.map((activity) => (
            <StyledProfileTableRow key={activity.id}>
              <TableCell sx={{ color: "white" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      border: `2px solid ${darkColors.buttonTop}`,
                    }}
                    src={activity.racerPhoto}
                  />
                  <Box>
                    <Typography
                      fontFamily={"MontserratBold"}
                      fontSize={fontSizes.heading3}
                    >
                      {activity.name}
                    </Typography>
                    <Typography fontSize={fontSizes.body}>
                      <Box
                        component="span"
                        sx={{ color: darkColors.tableGreen }}
                      >
                        {activity.status}
                      </Box>{" "}
                      <Box
                        component="span"
                        sx={{ color: darkColors.lightGray }}
                      >
                        {activity.type === "race"
                          ? "Race at"
                          : "For Placing Bet On"}{" "}
                      </Box>
                      <Box component="span" sx={{ color: "white" }}>
                        {activity.location}
                      </Box>
                    </Typography>
                  </Box>
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: 700,
                }}
              >
                {activity.timestamp}
              </TableCell>
              {/* <TableCell>
                <OddsChip
                  odds={activity.odds}
                  width={80}
                  boxShadow="-2px 0px 30px rgba(199, 123, 30, 0.7)"
                  px={2}
                />
              </TableCell> */}
              <TableCell sx={{ color: "white", fontSize: fontSizes.heading3 }}>
                <Box sx={{ display: "flex", alignItems: "start" }}>
                  <Typography pt={0.2}>
                    <CurrencyIcon />
                  </Typography>
                  +{activity.totalWinning}
                </Box>
              </TableCell>
            </StyledProfileTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default ActivitiesTable;
